import {
  ConsentAgreementTypeEnum,
  ConsentNameEnumType,
  useCurrentConsentAgreementTextQuery,
  useSaveConsentMutation,
} from '../../../../gql/generated/graphql';

const useMethodFiConsent = () => {
  const { data, loading } = useCurrentConsentAgreementTextQuery({
    variables: { agreementType: ConsentAgreementTypeEnum.Methodfi },
  });

  const [saveConsentMutation] = useSaveConsentMutation();

  const saveConsent = async () => {
    await saveConsentMutation({ variables: { type: ConsentNameEnumType.Methodfi } });
  };

  const consentText = data?.currentConsentAgreementText?.text ?? '';

  return {
    consentText,
    consentLoading: loading && !consentText,
    saveConsent,
  };
};

export default useMethodFiConsent;
